'use client';
/* Built In Imports */
import { memo, useState } from 'react';

/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import SubscribeBox from '@app-ps/Components/Ui/SubscribeBox';
import config from '@config';
/* Services */

/**
 * Renders the Subscribe Content component
 *
 * @param contentSection.section
 * @param contentSection.contentSection
 * @param {object} contentSection
 * @param {string} contentType
 * @param {string} language
 * @param {string} bgColor - Background Color
 * @param contentSection.contentType
 * @param contentSection.language
 * @param contentSection.contentObj
 * @param contentSection.ctaText
 * @param contentSection.bgColor
 * @param contentSection.hideSpamText
 * @param contentSection.pType
 * @param contentSection.region
 * @returns {ReactElement} Subscribe Content component
 */
const SubscribeContent = ({ sectionContent, ...props }) => {
  const [message, setMessage] = useState(null);
  const response = message => {
    setMessage(message);
  };
  return (
    <Box
      py="10px"
      mt={{ base: '0', md: '0rem', lg: '5rem' }}
      mb={{ base: '0', md: '0rem', lg: '5rem' }}
      pos="relative"
      px={{ base: '20px', md: '30px', lg: '0' }}
      background="#000000"
      {...props}
    >
      <Box
        className="clear"
        textAlign="center"
        maxW={{ md: '80%', lg: '824px' }}
        minW={{ base: '1px', sm: '320px' }}
        w="100%"
        mx="auto"
        bg="#000000"
        py={{
          base: props.isBlog ? '15px' : '30px',
          md: props.isBlog ? '30px' : '90px',
          lg: props.isBlog ? '30px' : '60px',
        }}
      >
        <Flex
          w="100%"
          justifyContent={{
            base: 'flex-start',
            md: 'space-between',
            lg: 'space-between',
          }}
          gridGap={{ base: '0', md: '20px' }}
          alignItems="center"
          flexWrap={{ base: 'wrap', md: 'nowrap' }}
        >
          {/* {!message ? ( */}
          <Flex
            mx={{ base: '0', md: 'auto' }}
            flexDir="column"
            w={{ base: '100%', md: '85%', lg: '85%' }}
            maxW={{ lg: '720px', xl: '720px', '2xl': '980px' }}
          >
            <Box
              marginLeft={{
                base: 0,
              }}
              textAlign={{ base: 'left', md: 'center' }}
              marginTop={{ base: '0', md: '20px' }}
              position="relative"
              zIndex="2"
              px={{ base: '16px', lg: '0' }}
              m={{ base: '0', md: '0', xl: '0 auto' }}
            >
              {/* <Box> */}
              <LazyLoadImageComponent
                width={{ base: '50%', lg: '302px', '2xl': '30%' }}
                height={{ lg: '55px' }}
                mb={{ base: '30px', lg: '20px' }}
                mx="auto"
                src={`${config.imgPath}/d/46272/1721917503-kolam-stayconnected.svg`}
              />
              <Box
                as="h2"
                textStyle="h2"
                fontSize={{ base: '1.25rem', md: '1.5rem', xl: '28px' }}
                lineHeight={{ base: '1.5rem', lg: '2rem', xl: '33.6px' }}
                textAlign="center"
                letterSpacing={'0.16px'}
                display={'flex'}
                alignItems={{ lg: 'center' }}
                justifyContent={'center'}
                gap={{ base: '.5rem', '2xl': '.8rem' }}
                flexDirection={{ base: 'column', lg: 'row' }}
                color="#FEFAF6"
                fontFamily="var(--FedraSerifDisplay-light)"
                maxW={{ base: '326px', md: '326px', lg: '100%' }}
                mx="auto"
                fontWeight="normal"
              >
                <Box display={{ md: 'block', base: 'contents' }}>
                  <Text as="span" fontWeight={700} color="#60ADFF">
                    {`${sectionContent?.content?.json?.title} `}
                  </Text>
                  <Text
                    as="span"
                    fontWeight={400}
                    fontFamily="var(--FedraSerifDisplay-Regular)"
                  >
                    {`${sectionContent?.content?.json?.title1} `}
                  </Text>
                </Box>
                <Text as="span" fontWeight={700}>
                  {sectionContent?.content?.json?.title2}
                </Text>
              </Box>

              <Text
                textAlign="center"
                fontSize={{ base: '.875rem', lg: '1.25rem' }}
                lineHeight={{ base: '1.4rem', lg: '2rem' }}
                letterSpacing={'0.32px'}
                marginBottom="10px"
                width={{ xl: '120%', '2xl': 'auto' }}
                maxW={{ base: '100%', md: '725px', lg: '725px' }}
                mx={{ base: 'auto', md: 'auto', xl: '1rem' }}
                mt="20px"
                mb="32px"
                fontFamily="var(--FedraSansStd-book)"
                color="#FEFAF6"
                fontWeight={350}
              >
                {sectionContent?.content?.json?.description}
              </Text>
            </Box>
            {/* </Box> */}
            <Box
              maxW={{ base: '100%', md: 470, lg: 530 }}
              mx={{ base: '0', lg: 'auto', xl: '0' }}
              display={{ xl: 'contents' }}
              px={{ base: '0px', lg: '0' }}
            >
              <SubscribeBox
                sectionContent={sectionContent}
                lang="en"
                response={response}
              />
            </Box>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default memo(SubscribeContent);
